import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { toQueryParams } from 'helpers/api';
import { createBaseQuery } from 'helpers/api';
import cookie from 'react-cookies';

export const adminRolesApi = createApi({
  reducerPath: 'adminRolesApi',
  baseQuery: createBaseQuery('admin_roles'),
  endpoints: builder => ({
    getAdminRoles: builder.query({
      query: params => `?${toQueryParams(params)}`,
    }),
    createAdminRole: builder.mutation({
      query: data => ({
        url: '/',
        method: 'POST',
        body: data,
      }),
    }),
    deleteAdminRole: builder.mutation({
      query: id => ({
        url: `/${id}`,
        method: 'DELETE',
      }),
    }),
    getSupportUsers: builder.query({
      query: () => '/support_users',
      transformResponse: ({ result }) => result.users,
      keepUnusedDataFor: 300,
    }),
    getSupportUsersStats: builder.query({
      query: () => '/stats',
    }),
  }),
});

export const {
  useLazyGetAdminRolesQuery,
  useCreateAdminRoleMutation,
  useDeleteAdminRoleMutation,
  useGetSupportUsersQuery,
  useGetSupportUsersStatsQuery,
} = adminRolesApi;
